import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminContentLockGracePeriodsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminContentLockGracePeriodsQuery = { __typename?: 'RootQueryType', contentLockGracePeriods?: { __typename?: 'PageOfContentLockGracePeriod', results?: Array<{ __typename?: 'ContentLockGracePeriod', id: string, schoolId: string, endDate: any }> | null } | null };


export const AdminContentLockGracePeriodsDocument = gql`
    query AdminContentLockGracePeriods {
  contentLockGracePeriods(limit: 250) {
    results {
      id
      schoolId
      endDate
    }
  }
}
    `;

/**
 * __useAdminContentLockGracePeriodsQuery__
 *
 * To run a query within a React component, call `useAdminContentLockGracePeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminContentLockGracePeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminContentLockGracePeriodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminContentLockGracePeriodsQuery(baseOptions?: Apollo.QueryHookOptions<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>(AdminContentLockGracePeriodsDocument, options);
      }
export function useAdminContentLockGracePeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>(AdminContentLockGracePeriodsDocument, options);
        }
// @ts-ignore
export function useAdminContentLockGracePeriodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>;
export function useAdminContentLockGracePeriodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminContentLockGracePeriodsQuery | undefined, AdminContentLockGracePeriodsQueryVariables>;
export function useAdminContentLockGracePeriodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>(AdminContentLockGracePeriodsDocument, options);
        }
export type AdminContentLockGracePeriodsQueryHookResult = ReturnType<typeof useAdminContentLockGracePeriodsQuery>;
export type AdminContentLockGracePeriodsLazyQueryHookResult = ReturnType<typeof useAdminContentLockGracePeriodsLazyQuery>;
export type AdminContentLockGracePeriodsSuspenseQueryHookResult = ReturnType<typeof useAdminContentLockGracePeriodsSuspenseQuery>;
export type AdminContentLockGracePeriodsQueryResult = Apollo.QueryResult<AdminContentLockGracePeriodsQuery, AdminContentLockGracePeriodsQueryVariables>;